import { DefaultCell } from '@silverfort/sf-components';
import { LogsTableRow } from '../types';
import { FC } from 'react';

type Props = LogsTableRow;

export const HeadlineCell: FC<Props> = ({ headline }) => {
    return <DefaultCell text={headline as string} />;
};
